'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../styleInject.js');

var css_248z = ".Radio-module_radiogroup__oQVEm:focus{outline:none}";
var styles = {"radiogroup":"Radio-module_radiogroup__oQVEm"};
styleInject["default"](css_248z, '9ae3478c-aa9e-405a-a079-c51f77517069');

exports["default"] = styles;
